import { useState, useEffect, useRef } from "react";
import { trackEvent } from "../analytics/trackEvent";

export default function NavbarEN({ heroHeadingRef }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    function handleScroll() {
      if (heroHeadingRef?.current) {
        const headingTop = heroHeadingRef.current.getBoundingClientRect().top;
        setHidden(headingTop <= 80);
      }
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [heroHeadingRef]);

  const handleCTA = () => {
    trackEvent("click_register_button", { ab: "EN-HERO", location: "navbar" });
    window.location.href = "https://app.cv-box.com/#signup";
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[999] transition-all duration-300 ${
        hidden ? "-translate-y-full opacity-0" : "translate-y-0 opacity-100"
      } ${mobileMenuOpen ? "bg-[#1a1a2e]/95 backdrop-blur-md" : "bg-transparent"}`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo */}
          <a href="/en" className="flex items-center">
            <img
              src="/images/logo/logo-white.svg" width={112} height={28}
              className="w-24 lg:w-28"
              alt="CV Box"
            />
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            <a href="#features" className="text-sm text-white/70 hover:text-white transition">
              Features
            </a>
            <a href="#pricing" className="text-sm text-white/70 hover:text-white transition">
              Pricing
            </a>
            <a href="#faq" className="text-sm text-white/70 hover:text-white transition">
              FAQ
            </a>
          </nav>

          {/* Right side */}
          <div className="hidden lg:flex items-center gap-4">
            {/* Language switcher */}
            <div className="flex items-center gap-1 bg-white/5 border border-white/10 rounded-full px-1 py-1">
              <a
                href="/en"
                className="px-3 py-1 text-xs font-medium bg-white/15 text-white rounded-full flex items-center gap-1"
              >
                🇬🇧 Eng
              </a>
              <a
                href="/ua"
                className="px-3 py-1 text-xs font-medium text-white/50 hover:text-white rounded-full transition flex items-center gap-1"
              >
                🇺🇦 Укр
              </a>
            </div>

            <a
              href="https://app.cv-box.com"
              className="text-sm text-white/70 hover:text-white transition"
            >
              Log in
            </a>

            <button
              onClick={handleCTA}
              className="py-2 px-5 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-sm font-bold rounded-full hover:from-green-400 hover:to-emerald-500 hover:shadow-lg hover:shadow-green-500/30 transition-all duration-300 cursor-pointer"
            >
              Start for free
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          >
            {mobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden pb-6 border-t border-white/10 mt-2 pt-4 space-y-4">
            <a href="#features" className="block text-sm text-white/70 hover:text-white">Features</a>
            <a href="#pricing" className="block text-sm text-white/70 hover:text-white">Pricing</a>
            <a href="#faq" className="block text-sm text-white/70 hover:text-white">FAQ</a>
            <div className="flex items-center gap-2 pt-2">
              <a href="/en" className="text-xs font-medium text-white bg-white/15 px-3 py-1 rounded-full flex items-center gap-1">🇬🇧 Eng</a>
              <a href="/ua" className="text-xs font-medium text-white/50 px-3 py-1 rounded-full flex items-center gap-1">🇺🇦 Укр</a>
            </div>
            <div className="pt-2 flex flex-col gap-3">
              <a href="https://app.cv-box.com" className="text-sm text-white/70">Log in</a>
              <button onClick={handleCTA} className="py-2.5 px-5 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-sm font-bold rounded-full w-full cursor-pointer">
                Start for free
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
